import { useEffect, useRef } from "react";
import { MapPosition, MapSearchLogger } from "./map-search-logger";

/**
 * Creates one logger per mount of the map search, so its logs share a session ID.
 * Mount the component using this when the search opens and unmount it when it closes.
 */
export const useMapSearchLogger = (getMapPosition: () => MapPosition) => {
    const searchLogger = useRef<MapSearchLogger | null>(null);

    useEffect(() => {
        const logger = new MapSearchLogger(getMapPosition);
        searchLogger.current = logger;
        return logger.onClose;
    }, []);

    // The logger only exists after mounting, so these read the ref when called rather than when rendered
    return {
        onSearch: (...args: Parameters<MapSearchLogger["onSearch"]>) => searchLogger.current?.onSearch(...args),
        onResultClicked: (...args: Parameters<MapSearchLogger["onResultClicked"]>) => searchLogger.current?.onResultClicked(...args),
    };
};
